import { useEffect, useState } from 'react';
import { fetchSurveyData } from '../api/staff.js';

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleString('en-MY', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

function SurveyData() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    void (async () => {
      const result = await fetchSurveyData();
      setLoading(false);
      if (!result.ok) {
        setError(result.error || 'Failed to load survey data');
        return;
      }
      setCustomers(result.customers);
    })();
  }, []);

  if (loading) {
    return <p className="text-center text-slate-500">Loading survey data…</p>;
  }

  if (error) {
    return <p className="text-center text-red-600">{error}</p>;
  }

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-800">Survey Data</h2>
        <p className="mt-1 text-sm text-slate-500">
          {customers.length} completed submission{customers.length === 1 ? '' : 's'}
        </p>
      </div>

      {customers.length === 0 ? (
        <p className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-500">
          No customer submissions yet. Share your QR code to get started.
        </p>
      ) : (
        <ul className="space-y-3">
          {customers.map((c) => (
            <li
              key={c.uuid}
              className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm"
            >
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="font-semibold tabular-nums text-slate-900">{c.contact ?? '—'}</p>
                  <p className="mt-1 text-xs text-slate-500">{formatDate(c.createdAt)}</p>
                </div>
                <span className="shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700">
                  #{c.submissionIndex ?? '?'}
                </span>
              </div>
              <div className="mt-2 flex flex-wrap gap-2 text-xs text-slate-600">
                {c.language && <span>Lang: {c.language.toUpperCase()}</span>}
                {c.hasTng && <span>TNG assigned</span>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SurveyData;
